import { payInvoiceInPublic } from '@modusign/openapi-client-payment';
import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import LoadingStatus from '@libs/loading-status';

import workspaceService from '@app/libs/workspaceService';
import {
  changePaymentNotification as changePaymentNotificationAPI,
  fetchPaymentNotification as fetchPaymentNotificationAPI,
} from '@app/store/transport-layer/payment/notifications';
import { RootState } from '@app/store/types';

/** @deprecated subscriptionData redux slice가 없어진다면 제거해주세요. */
export const updatePrimaryPaymentMethodSuccess = createAction(
  'UPDATE_PRIMARY_PAYMENT_METHOD_SUCCESS'
);

export const changePaymentNotification = createAsyncThunk(
  'payment/changePaymentNotificationAPI',
  ({ contact, type }: { contact: string; type: 'EMAIL' }) => {
    return changePaymentNotificationAPI({
      contact,
      type,
      workspaceId: workspaceService.getWorkspaceId(),
    });
  }
);

export const fetchPaymentNotification = createAsyncThunk(
  'payment/fetchPaymentNotificationAPI',
  () => {
    return fetchPaymentNotificationAPI(workspaceService.getWorkspaceId());
  }
);

export const payInvoice = createAsyncThunk('payment/payInvoice', (invoiceId: string) => {
  return payInvoiceInPublic(workspaceService.getWorkspaceId(), invoiceId);
});

interface PaymentState {
  payment: {
    notification: {
      changeLoadingStatus: LoadingStatus;
      contact: string | null;
      createdAt: string | null;
      fetchLoadingStatus: LoadingStatus;
      id: string | null;
      type: 'EMAIL' | null;
      userId: string | null;
    };
  };
}

const initialPaymentState: PaymentState = {
  payment: {
    notification: {
      changeLoadingStatus: LoadingStatus.IDLE,
      contact: null,
      createdAt: null,
      fetchLoadingStatus: LoadingStatus.IDLE,
      id: null,
      type: null,
      userId: null,
    },
  },
};

export const { reducer } = createSlice({
  name: 'payment',
  initialState: initialPaymentState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentNotification.pending, (state) => {
      state.payment.notification.fetchLoadingStatus = LoadingStatus.PENDING;
    });
    builder.addCase(fetchPaymentNotification.fulfilled, (state, action) => {
      if (action.payload) {
        const { contact, createdAt, id, type, userId } = action.payload;
        state.payment.notification.contact = contact;
        state.payment.notification.createdAt = createdAt;
        state.payment.notification.id = id;
        state.payment.notification.type = type;
        state.payment.notification.userId = userId;
      }
      state.payment.notification.fetchLoadingStatus = LoadingStatus.SUCCEEDED;
    });
    builder.addCase(fetchPaymentNotification.rejected, (state) => {
      state.payment.notification.fetchLoadingStatus = LoadingStatus.FAILED;
    });
    builder.addCase(changePaymentNotification.pending, (state) => {
      state.payment.notification.changeLoadingStatus = LoadingStatus.PENDING;
    });
    builder.addCase(changePaymentNotification.fulfilled, (state, action) => {
      if (action.payload) {
        const { contact, createdAt, id, type, userId } = action.payload;
        state.payment.notification.contact = contact;
        state.payment.notification.createdAt = createdAt;
        state.payment.notification.id = id;
        state.payment.notification.type = type;
        state.payment.notification.userId = userId;
      }
      state.payment.notification.changeLoadingStatus = LoadingStatus.SUCCEEDED;
    });
    builder.addCase(changePaymentNotification.rejected, (state) => {
      state.payment.notification.changeLoadingStatus = LoadingStatus.FAILED;
    });
  },
});

const getPaymentState = (state: RootState) => state.payment;

const getPaymentPayment = (state: RootState) => getPaymentState(state).payment;

const getPaymentNotification = (state: RootState) => getPaymentPayment(state).notification;
export const getPaymentNotificationChangeLoadingStatus = (state: RootState) =>
  getPaymentNotification(state).changeLoadingStatus;
export const getPaymentNotificationContact = (state: RootState) =>
  getPaymentNotification(state).contact;
export const getPaymentNotificationFetchLoadingStatus = (state: RootState) =>
  getPaymentNotification(state).fetchLoadingStatus;
export const getPaymentNotificationId = (state: RootState) => getPaymentNotification(state).id;
